import { useEffect, useState } from 'react';

const useScrollableDown = () => {
  const [isScrollable, setIsScrollable] = useState(false);
  const checkScroll = () => {
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = window.innerHeight;
    setIsScrollable(scrollHeight > clientHeight);
  };

  useEffect(() => {
    checkScroll(); // initial check

    const handleResize = () => checkScroll();
    const handleScroll = () => checkScroll();

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    const observer = new MutationObserver(() => {
      checkScroll();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
      observer.disconnect();
    };
  }, []);

  return isScrollable;

};

export default useScrollableDown;
